<template>
  <div class="rule-wrapper">
    <div class="container">
      <h1></h1>
      <h1>QUY TẮC TRÒ CHƠI – NUMBER GAME</h1>
      <button type="button" class="collapsible">1. NUMBER GAME 75 BÓNG</button>
      <div class="content" style="display: block;">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block;">
          <div class="rulesContent">
            <ul class="listSummary">
              <li><p>Number game hoạt động 24 / 7, bạn có thể tham gia cuộc chơi bằng cách đặt cược vào một con số bất kỳ được ghi trên các quả bóng sẽ được rút ra từ máy bingo blower. Tổng cộng có 75 quả bóng được đánh số từ 1 đến 75.</p></li>  
              <li><p>Sẽ có 3 quả bóng được rút ra trong một cuộc chơi (game).</p></li>
              <li><p>Các quả bóng sẽ được trả về máy Bingo sau mỗi cuộc chơi để bắt đầu một cuộc chơi mới.</p></li>
              <li><p>Có tất cả 38 quả bóng thuộc "Over/Tài" và 37 quả bóng thuộc "Under/Xỉu".</p></li>
              <li><p>Có tất cả 38 quả bóng thuộc "Odd/Lẻ" và 37 quả bóng thuộc "Even/Chẵn".</p></li>
              <li><p>Có tất cả 38 quả bóng thuộc "Red/Đỏ" và 37 quả bóng thuộc "Blue/Xanh".</p></li>
            </ul>
            <h3>Running Games (Trực tiếp)</h3>
            <ul class="listDetail">
              <li><h5>Next Over/Under</h5>
                  <p>Dự đoán kết quả "Tài/ Xỉu" của quả bóng tiếp theo.</p>
              </li>
              <li><h5>Next Odd/Even</h5>
                  <p>Dự đoán kết quả "Lẻ/ Chẵn" của quả bóng tiếp theo.</p></li>
              <li><h5>Next Red/Blue</h5>
                  <p>Dự đoán kết quả "Đỏ/ Xanh" của quả bóng tiếp theo.</p></li>
              <li><h5>Next Combo:</h5>
                  <p><strong>Over/Odd , Under/Odd, Over/ Even, Under/ Even</strong></p>
                  <p>Dự đoán kết quả "Tài / Lẻ", "Xỉu / Lẻ", "Tài / Chẵn" , "Xỉu / Chẵn".</p>
                  <p>
                    Ví dụ: Nếu quả bóng được rút ra là 30, và người chơi đặt cược kết quả "Xỉu / Chẵn" sẽ giành chiến thắng. Tất cả các đặt cược khác đều thua.
                  </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button type="button" class="collapsible">2. NUMBER GAME 35 BÓNG</button>
      <div class="content" style="display: block;">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block;">
          <div class="rulesContent">
            <ul class="listSummary">
              <li><p>Number game hoạt động 24 / 7, bạn có thể tham gia cuộc chơi bằng cách đặt cược vào một con số bất kỳ được ghi trên các quả bóng sẽ được rút ra từ máy bingo blower. Tổng cộng có 35 quả bóng được đánh số từ 1 đến 35.</p></li>  
              <li><p>Sẽ có 3 quả bóng được rút ra trong một cuộc chơi ( game).</p></li>
              <li><p>Các quả bóng sẽ được trả về máy Bingo sau mỗi cuộc chơi để bắt đầu một cuộc chơi mới.</p></li>
              <li><p>Có tất cả 18 quả bóng thuộc "Over/Tài" và 17 quả bóng thuộc "Under/Xỉu".</p></li>
              <li><p>Có tất cả 18 quả bóng thuộc "Odd/Lẻ" và 17 quả bóng thuộc "Even/Chẵn".</p></li>
              <li><p>Có tất cả 18 quả bóng thuộc "Red/Đỏ" và 17 quả bóng thuộc "Blue/Xanh".</p></li>
            </ul>
            <h3>Running Games (Trực tiếp)</h3>
            <ul class="listDetail">
              <li><h5>Next Over/Under</h5>
                  <p>Dự đoán kết quả "Tài/ Xỉu" của quả bóng tiếp theo.</p>
              </li>
              <li><h5>Next Odd/Even</h5>
                  <p>Dự đoán kết quả "Lẻ/ Chẵn" của quả bóng tiếp theo.</p></li>
              <li><h5>Next Red/Blue</h5>
                  <p>Dự đoán kết quả "Đỏ/ Xanh" của quả bóng tiếp theo.</p></li>
              <li><h5>Next Combo:</h5>
                  <p><strong>Over/Odd , Under/Odd, Over/ Even, Under/ Even</strong></p>
                  <p>Dự đoán kết quả "Tài / Lẻ", "Xỉu / Lẻ", "Tài / Chẵn" , "Xỉu / Chẵn".</p>
                  <p>Ví dụ: Nếu quả bóng được rút ra là 16, và người chơi đặt cược kết quả "Xỉu / Chẵn" sẽ giành chiến thắng. Tất cả các đặt cược khác đều thua.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button type="button" class="collapsible">3. ĐIỀU KHOẢN &amp; ĐIỀU KIỆN</button>
      <div class="content" style="display: block;">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block;">
          <div class="rulesContent">
            <ol style="padding-left: 16px;">
              <li>NUMBER GAME chỉ áp dụng cho tất cả các thành viên đã đăng ký.</li>
              <li>
                Kết quả của tất cả các bảng của NUMBER GAME sẽ được hiển thị ngay lập tức
                trên báo cáo lịch sử kết quả, và là thông tin chính thức
              </li>
              <li>
                Nhà Cung Cấp Trò Chơi có quyền hủy hoặc vô hiệu hóa lượt rút thăm
                hoặc lượt đặt cược bị ảnh hưởng trong trường hợp xảy ra sự cố kỹ
                thuật, trục trặc dưới mọi hình thức, bao gồm, nhưng không giới hạn
                như lỗi phần mềm, phần cứng hoặc lỗi kết nối.
              </li>
              <li>
                Nhà Cung Cấp Trò Chơi có quyền hủy hoặc vô hiệu hóa vô hiệu hóa
                lượt rút thăm hoặc lượt đặt cược bị ảnh hưởng trong trường hợp có
                bất kỳ nghi ngờ nào về việc người chơi đang thực hiện hành vi lừa
                đảo, thông đồng hoặc các hành động bất hợp pháp khác.
              </li>
              <li>
                Nhà Cung Cấp Trò Chơi có quyền hủy hoặc vô hiệu hóa lượt rút thăm
                hoặc lượt đặt cược bị ảnh hưởng trong trường hợp xảy ra lỗi (do
                Quản trị viên của nhà Cung Cấp Trò Chơi nhập không chính xác) hoặc
                lỗi hệ thống, dẫn đến việc gây ra tỷ lệ cược không chính xác và
                được sử dụng cho NUMBER GAME.
              </li>
              <li>
                Các lệnh cược đã được chấp nhận kèm theo Mã Số Rút Thăm (Draw ID)
                trong thông báo xác nhận cuối cùng sẽ có hiệu lực ngay cả khi
                thành viên sau đó đăng xuất hoặc bị ngắt kết nối vì bất kỳ lý do
                nào từ trò chơi, chẳng hạn như kết nối kém, ngắt kết nối, v.v..
              </li>
              <li>
                Mã Số Phiếu Cược là một Số Tham chiếu cho tất cả các lệnh đặt cược
                được thực hiện và xác nhận thành công. Mã Số Phiếu Cược biểu thị
                cho một lệnh đặt cược hợp lệ. Trong trường hợp Mã Số Phiếu Cược
                không được tạo ra sau khi đặt cược, điều đó có nghĩa là lệnh đặt
                cược không thành công và không hợp lệ. Do đó, hãy tránh thực hiện
                lệnh đặt cược lặp lại với nhiều giao dịch đặt cược vào những giây
                cuối cùng của lần rút thăm hiện tại.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  head () {
    return {
      title: 'rule',
    };
  },
};
</script>

<style>
body, #app {
  background: #45464E url(/images/kenobg.jpg) no-repeat fixed;
  color: #fff;
  font-size: 1rem;
}
h1,
h2 {
  /* color: #161c2d; */
  font-size: 24px;
  font-weight: 500;
  margin: 20px 0 30px;
}

h3 {
  font-size: 20px;
  margin: 0;
  padding: 10px 0;
}

thead {
  color: black;
}
ol {
  text-align: left;
}

table {
  border: 1px solid #292a2e;
}

td {
  vertical-align: top;
  padding: 0.1in 5.75pt;
}

.rule-wrapper {
  text-align: left;
  /* padding: 80px 0; */
}
.rule-wrapper a {
  color: #1652f0;
  text-decoration: none;
}

.tablestyle {
  border-spacing: 0;
  border-collapse: separate !important;
  width: 100%;
  text-align: center;
}

.tablestyle thead th {
  background: #37405a;
  color: #b0bfd3;
  font-weight: normal;
  /*border-left: 1px solid #4A82F0;
    border-bottom: 1px solid #4A82F0;*/
}

.tablestyle th,
.tablestyle td {
  padding: 2px 10px;
  background: #fff;
  color: #4d4f5c;
}

.tablestyle .currency {
  text-align: right;
}

.tablestyle tbody tr td {
  vertical-align: top;
}

.tablestyle tbody tr:nth-of-type(2n + 0) td {
  background: #f2f6fe;
}

.input-group .form-control {
  border: 0;
}

.input-group-text {
  background: #fff;
  border: 0;
  line-height: normal;
}
.pull-right {
  float: right;
}

.resulticon {
  margin: 0 auto;
  display: block;
  font-size: 10px;
  background-color: #999;
  text-align: center;
  height: 18px;
  width: 18px;
  line-height: 18px;
  border-radius: 18px;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
}

h5 {
  background: #292a2e;
  color: #fff;
  line-height: 50px;
  height: 50px;
  width: 100%;
}

.paragraphy-style {
  text-align: left;
  padding-left: 16px;
  padding-right: 16px;
}

.tablestyle td,
.tablestyle th {
  padding: 10px;
}

.tablecont {
  padding-left: 16px;
  padding-right: 16px;
}

.table-border {
  border-bottom: 1px solid #e3ecfe;
}

@media screen and (max-width: 480px) {
  .tablestyle td,
  .tablestyle th {
    padding: 5px;
    border-right: 1px solid #37405a;
  }
}

/* Style the tab */
.tab {
  overflow: hidden;
  width: inherit;
  /* filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#FDFCFC', endColorstr='#FBF9F9'); */
}

/* Style the buttons inside the tab */
.tab button {
  float: left;
  margin: 0;
  background-color: #f2f0f0;
  border: 1px solid #c0c0c0;
  color: #444;
  text-shadow: 0 1px #eee;
  outline: none;
  height: 100%;
  cursor: pointer;
  padding: 14px;
  width: 50%;
  transition: 0.3s;

  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 16px;
  /* background-image: linear-gradient(top, #FDFCFC, #FBF9F9 50%, #F7F5F6 50%, #F2F0F0);  */
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  /* display: inline-block; */
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: white;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: white !important;
  background-image: -webkit-linear-gradient(
    top,
    white,
    white 50%,
    white 50%,
    white
  );
  border-bottom: none;
}

/* Style the tab content */
.tabcontent1,
.tabcontent2,
.tabcontent3 {
  text-align: left;
  display: none;
  border: 1px solid #ccc;
  border-top: none;
  animation: fadeEffect 1s;
  padding: 20px;
}

.center {
  text-align: center;
}
.table-payout {
  text-align: center;
  width: 100%;
}
.container-center {
  text-align: -webkit-center;
}
.left {
  text-align: left;
}
.list-bet {
  text-align: center;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(2) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(4),
.list-bet tr td:nth-child(6) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}

/* Go from zero to full opacity */
@keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
button {
  border-radius: 0;
}
.collapsible {
  color: black!important;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border-bottom: none;
  border: 1px solid #c0c0c0;
  text-align: left;
  outline: none;
  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 18px;
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  position: relative;
}

.active,
.collapsible:hover {
  background-image: -webkit-linear-gradient(
    top,
    white,
    white 50%,
    white 50%,
    white
  );
}

td {
  border: 1pt solid;
}
.content {
  display: none;
  overflow: hidden;
  background-color: #45464E;
}

@media (max-width: 540px) {
  button {
    font-size: 13px !important;
  }
}

.top-navbar {
  text-align: center;
  background: #292a2e;
  line-height: 50px;
  height: 50px;
  width: 100%;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.back-arrow {
  color: #fff;
  font-size: 24px;
  float: left;
  height: 24px;
  line-height: 24px;
  position: absolute;
  left: 4px;
  top: 14px;
}

.back-arrow:hover {
  color: #fff;
  text-decoration: none;
}

.gli {
  text-align: center;
}

.gli a {
  text-decoration: underline;
}
</style>

<style lang="scss" scoped>
.listSummary {
  margin-bottom: 20px;
}

.rulesContent ul, .rulesContent ol {
    padding-left: 35px;
}

.rulesContent p {
    margin-bottom: 10px;
}

.rulesContent .listDetail {
    padding-left: 17px;
}

.rulesContent h5 {
    background: none;
}
</style>